import { ApolloProvider } from '@apollo/client'
import { type ReactNode } from 'react'
import { client } from './apolloClient'

type OPDataProviderProps = { children: ReactNode }

export const OPDataProvider = ({ children }: OPDataProviderProps) => (
  <ApolloProvider client={client}>{children}</ApolloProvider>
)
